import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class SupplyCaravanBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.SUPPLY_CARAVAN;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default SupplyCaravanBuildingTileEntity;
